export default {
  getLiveLocalCategories({ state, commit }, payload) {
    if (!this.$lodash.isNil(state.livelocalCategories)) {
      this.$apiContent.getKeywordsChildren(payload.categoryId).then((data) => {
        commit('setLiveLocalCategories', data)
        commit('SET_LOADED', { type: 'liveLocalCategories', value: true }, { root: true })
      })
    } else {
      commit('SET_LOADED', { type: 'liveLocalCategories', value: true }, { root: true })
    }
  }
}
